import PubSub from "pubsub-js";
import gsap from 'gsap';

var ModalForm = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-ModalForm',
  };

  $.extend(true, this.options, options);

};

ModalForm.prototype.init = function () {

  var self = this;

  this.$closeX = this.options.$el.find(`.${self.options.baseClass}__closeX`)
  this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`);
  this.$firstCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:first-child`);
  this.$secondCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:last-child`);
  self.$inner = self.options.$el.find(`.${self.options.baseClass}__inner`);
  self.$overlay = self.options.$el.find(`.${self.options.baseClass}__overlay`);

  $('[href="#open-form-modal"]').on('click', function (e) {

    e.preventDefault();
    self.open();

  });

  this.$closeX.on('click', function () {

    self.close();

  });

  self.$overlay.on('click', () => self.close());

  $(document).keyup(function (e) {
    if (e.keyCode === 27) self.close();
  });

};

ModalForm.prototype.open = function () {

  var self = this;

  gsap.timeline({
      defaults: {
        ease: "expo.out",
      }
    })
    .set(self.options.$el, {
      zIndex: 2002,
      visibility: "visible",
    })
    .fromTo(self.options.$el, {
      opacity: 0
    }, {
      duration: .2,
      opacity: 1,
    })
    .fromTo(self.$inner, {
      xPercent: 100
    }, {
      duration: 0.5,
      xPercent: 0
    }, "<.1")
    // close x
    .fromTo(self.$closeXSpans, {
      width: 0,
    }, {
      duration: 0.25,
      ease: "power3.out",
      width: 20
    })
    .fromTo(self.$firstCloseXSpan, {
        rotate: 0
      }, {
        duration: 0.25,
        rotate: 45,
        ease: "power1.inOut"
      },
      ">-0.1"
    )
    .fromTo(self.$secondCloseXSpan, {
        rotate: 0
      }, {
        duration: 0.25,
        rotate: -45,
        ease: "power1.inOut"
      },
      "<"
    );

};

ModalForm.prototype.close = function () {

  var self = this;

  gsap.timeline({
      defaults: {
        ease: "expo.out",
      }
    })
    .to(self.$closeXSpans, {
      duration: 0.25,
      rotate: 0,
      ease: "power1.inOut"
    })
    .to(self.$closeXSpans, {
        duration: 0.25,
        width: 0,
        ease: "power3.in"
      },
      ">-0.1"
    )
    .to(self.$inner, {
      duration: 0.4,
      xPercent: 100,
    })
    .to(self.options.$el, {
      opacity: 0,
      duration: 0.2,
    }, "<")
    .set(self.options.$el, {
      zIndex: -1,
      visibility: "hidden",
    });

};

export default ModalForm;